import React from 'react';
import { getChartColor } from 'components/DeviceDetails/helper';
import { removeSpaces } from './helper';

const ChartGradients = ({ lines }) => {
    return (
        <>
            {lines?.map((label) => {
                const stopColor = getChartColor(label);
                return (
                    <linearGradient
                        key={label}
                        id={`chartGradient-${removeSpaces(label)}`}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                    >
                        <stop
                            offset="5%"
                            stopColor={stopColor}
                            stopOpacity={0.8}
                        />
                        <stop
                            offset="95%"
                            stopColor={stopColor}
                            stopOpacity={0}
                        />
                    </linearGradient>
                );
            })}
        </>
    );
};

export default ChartGradients;
